export const colors = {
  primaryBlue: "#3366D6",
  darkBlue: "#031741",
  primaryGrey: "#888888",
  grey50: "#F7F7F7",
  grey100: "#E4E4E4",
  grey200: "#ABAAAC",
  grey300: "#707070",
  darkGrey: "#454545",
  disabled: "#1c56ce",
  background: "#F8F9FA",
  primaryGreen: "#00AF50",
  primaryRed: "#FF0000",
  primaryYellow: "#FFFF00",
  starkWhite: "#FFFFFF",
  selectedBlue: "#009ef7",
  primaryOrange: "#FF8039",
  primaryPurple: "#70309F",
  primaryWhite: "#FFFFFF",
  primaryBlack: "#000000",
  stashBlue: "#3A6BD8",
  backgroundBlue: "hsla(195, 100%, 90%, 0.5)",
}

export const containedButtonStyles = {
  backgroundColor: colors.primaryOrange,
  textTransform: "none",
  fontWeight: "bold",
}

export const borderStyles = {
  border: `1px solid ${colors.grey100}`,
  borderTop: `1px solid ${colors.grey100}`,
  borderBottom: `1px solid ${colors.grey100}`,
}
